<div class="logo">
    <div class="picture" alt="AntemetA" [routerLink]="'/'">
    </div>
</div>
